<template>
  <div>
    <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="showConfigurationGroupIcon" :class="$style.iconSvg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="48" cy="48" r="46.5" stroke="#202D38" stroke-width="3"/><path fill-rule="evenodd" clip-rule="evenodd" d="M59.103 35.359l-11.637-5.724-11.637 5.724-2.901 12.983 8.096 10.369h12.885l8.096-10.369-2.902-12.983zM49.07 26.373a3.633 3.633 0 00-3.208 0l-11.637 5.724a3.635 3.635 0 00-1.943 2.469L29.38 47.549a3.635 3.635 0 00-.03 1.44l-2.091 1.029a2.401 2.401 0 00-1.284 1.631l-1.917 8.578a2.402 2.402 0 00.45 2.002l5.35 6.85a2.401 2.401 0 001.892.923h8.512c.74 0 1.437-.34 1.892-.923l5.257-6.733h1.178l5.257 6.733a2.401 2.401 0 001.892.923h8.512c.74 0 1.438-.34 1.893-.923l5.348-6.85c.442-.567.608-1.301.451-2.002l-1.917-8.578a2.401 2.401 0 00-1.284-1.631l-3.105-1.527a3.63 3.63 0 00-.084-.942L62.65 34.566a3.635 3.635 0 00-1.943-2.47L49.07 26.374zm15.68 24.358L56.774 60.95a3.635 3.635 0 01-2.864 1.397h-2.273l4.102 5.254h8.512l5.349-6.85-1.917-8.577-2.931-1.442zM44.365 62.346h-3.34a3.635 3.635 0 01-2.865-1.397l-7.681-9.838-2.16 1.062-1.917 8.577 5.349 6.85h8.512l4.102-5.254zm3.103-24.53a7.27 7.27 0 00-7.27 7.27 7.27 7.27 0 1014.54 0 7.27 7.27 0 00-7.27-7.27zm-3.634 7.27a3.635 3.635 0 117.27 0 3.635 3.635 0 01-7.27 0z" fill="#202D38"/></svg>
    <div
      v-else
      :class="containerClassName"
    >
      <i :class="iconOneClassName" />
      <i :class="iconTwoClassName" />
      <i
        :class="iconThreeClassName"
        :title="title"
      />
      <i
        v-if="showActiveDirectoryIcons"
        :class="iconFourClassName"
      />
      <i
        v-if="showActiveDirectoryIcons"
        :class="iconFiveClassName"
        :title="title"
      />
    </div>
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapGetters } from 'vuex';
import icons from 'client/css/icons.css';

const {
  configurationGroup, group, systemGroup, userGroup,
} = ItemTypeConsts;

export default {
  name: 'GroupTypeIcon',

  props: {
    item: {
      type: Object,
      required: true,
      validator: function validator(value) {
        return !!(value
            && (value.type === userGroup
              || value.type === systemGroup
              || value.type === configurationGroup));
      },
    },
    itemType: {
      type: String,
      default: ItemTypeConsts.userGroup,
    },
    smallIcon: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    // This is done because we're introducing an SVG icon.
    if (this.item.type === configurationGroup) {
      return {};
    }
    const iconClassNames = [
      this.smallIcon
        ? this.$style.iconSmall
        : this.$style.iconLarge,
      icons.iconStackIcon,
    ];

    const { type } = this.item;

    const typeValues = {
      [systemGroup]: {
        iconTwoClassName: 'jc-groups-systems-2',
        iconThreeClassName: 'jc-groups-systems-3',
        title: 'System Group',
      },
      [userGroup]: {
        iconTwoClassName: 'jc-groups-users-2',
        iconThreeClassName: 'jc-groups-users-3',
        title: 'User Group',
      },
    };

    const data = {
      containerClassName: [
        icons.iconStack,
        this.smallIcon
          ? this.$style.containerSmall
          : this.$style.containerLarge,
      ],
      iconOneClassName: [
        ...iconClassNames,
        this.$style.iconDark,
        'jc-groups-1',
      ],
      iconTwoClassName: [
        ...iconClassNames,
        this.$style.iconLight,
        typeValues[type].iconTwoClassName,
      ],
      iconThreeClassName: [
        ...iconClassNames,
        this.$style.iconLight,
        typeValues[type].iconThreeClassName,
      ],
      iconFourClassName: [
        ...iconClassNames,
        this.$style.whiteIconOverlay,
        'jc-groups-badge-bg',
      ],
      iconFiveClassName: [
        ...iconClassNames,
        this.$style.iconBlue,
        'jc-groups-ad-badge',
      ],
      title: typeValues[type].title,
    };

    return data;
  },

  computed: {
    showActiveDirectoryIcons() {
      if (this.isManagedByActiveDirectory) {
        return this.isManagedByActiveDirectory()(this.item.id);
      }

      return false;
    },
    showConfigurationGroupIcon() {
      return this.item.type === configurationGroup;
    },
  },

  beforeCreate() {
    const { itemType } = this.$options.propsData;

    if (itemType === group || itemType === userGroup) {
      this.$options.methods = {
        ...this.$options.methods,
        ...mapGetters(StoreModuleMap[itemType], ['isManagedByActiveDirectory']),
      };
    }
  },

  methods: {},
};
</script>
<style scoped module>
@value (jcInformationalBase, jcGrey700, jcGrey100) from '~css/brand-colors.css';

.containerLarge {
  height: 33px;
  width: 33px;
}

.containerSmall {
  height: 21px;
  width: 21px;
}

.iconLarge {
  font-size: 33px;
}

.iconSmall {
  font-size: 21px;
}

.iconSvg {
  width: 33px;
}

.iconBlue {
  color: jcInformationalBase;
}

.iconDark {
  color: jcGrey700;
}

.iconLight {
  color: jcGrey100;
}

.whiteIconOverlay {
  color: white;
}
</style>
